import { createApi } from "@reduxjs/toolkit/query/react";
import CustomFetchBase from "../CustomFetchBase";

export const UserAddonApi = createApi({
  reducerPath: "UserAddonApi",
  baseQuery: CustomFetchBase,
  tagTypes: ["USERADDONAPI"],
  endpoints: (build) => ({
    getUserAddons: build.query({
      query: ({ page = 1, limit = 10, userId = "", status = "" }) => ({
        url: `/user-addon?page=${page}&limit=${limit}&userId=${userId}&status=${status}`,
        method: "GET",
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      providesTags: ["USERADDONAPI"],
    }),

    getUserAddonById: build.query({
      query: ({ id }) => ({
        url: `/user-addon/${id}`,
        method: "GET",
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      providesTags: ["USERADDONAPI"],
    }),

    purchaseAddon: build.mutation({
      query: ({ data }) => ({
        url: `/user-addon`,
        method: "POST",
        body: data,
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      invalidatesTags: ["USERADDONAPI"],
    }),

    updateUserAddon: build.mutation({
      query: ({ id, data }) => ({
        url: `/user-addon/${id}`,
        method: "PUT",
        body: data,
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      invalidatesTags: ["USERADDONAPI"],
    }),

    deleteUserAddon: build.mutation({
      query: ({ id }) => ({
        url: `/user-addon/${id}`,
        method: "DELETE",
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      invalidatesTags: ["USERADDONAPI"],
    }),
  }),
});

export const {
  useGetUserAddonsQuery,
  useGetUserAddonByIdQuery,
  usePurchaseAddonMutation,
  useUpdateUserAddonMutation,
  useDeleteUserAddonMutation,
  useLazyGetUserAddonsQuery,
  useLazyGetUserAddonByIdQuery,
} = UserAddonApi;
